<div class="roster-container" [class.fullscreen-mode]="isFullscreen" #rosterContainer>
    <!-- Header with Nav and Actions -->
    <div class="roster-header">
        <div class="action-grp-left">
            <button (click)="toggleEmployeeColumn()" matTooltip="Toggle Employee Column"
                style="border: 1px solid #e2e8f0; background: white; transform: scaleX(-1);   min-width: unset; padding: 5px !important;">
                <img style="height: 35px;" [src]="showEmployeeColumn ? 'assets/images/icons/pane-close.svg'
                    : 'assets/images/icons/pane-open.svg'">
            </button>
            <div class="week-navigation">
                <button mat-icon-button (click)="prevWeek()"
                    *ngIf="!isViewerMode()"><mat-icon>chevron_left</mat-icon></button>
                <div class="week-info" (click)="!isViewerMode() && openSelectWeekDialog()"
                    [style.cursor]="isViewerMode() ? 'default' : 'pointer'">
                    <span class="week-num">Week {{ header?.week_number || '...' }}</span>
                    <span class="week-date">{{ header?.start_date | date:'dd MMM' }} - {{ header?.end_date |
                        date:'dd MMM yyyy' }}</span>
                </div>
                <button mat-icon-button (click)="nextWeek()"
                    *ngIf="!isViewerMode()"><mat-icon>chevron_right</mat-icon></button>
                <button mat-flat-button (click)="openRosterList()" matTooltip="Roster List" class="list-btn"
                    *ngIf="!isViewerMode()">
                    <mat-icon>list</mat-icon>
                    <span>Roster</span>
                </button>
            </div>
        </div>
        <div class="shop-selection"
            *ngIf="(currentUser?.user_type !== 'SHOP' && userShops.length > 0) || isViewerMode()">
            <button mat-flat-button [disabled]="isViewerMode()" (click)="openShopSelection()" class="shop-select-btn"
                [style.cursor]="isViewerMode() ? 'default' : 'pointer'">
                <mat-icon>store</mat-icon>
                <span>{{ getSelectedShopName() }}</span>
                <mat-icon *ngIf="!isViewerMode()">arrow_drop_down</mat-icon>
            </button>
        </div>
        <div class="header-actions">


            <button mat-flat-button (click)="toggleRounded()" matTooltip="Toggle Rounded Attendance Hours"
                *ngIf="header && !isNoShopsSelected()"
                [style.background-color]="showRounded ? '#e0f2fe !important' : 'white !important'"
                [style.color]="showRounded ? '#0369a1 !important' : '#4a5568 !important'"
                [style.border-color]="showRounded ? '#bae6fd !important' : '#e2e8f0 !important'">
                <mat-icon>{{ showRounded ? 'av_timer' : 'query_builder' }}</mat-icon>
                <span>Rounded</span>
            </button>

            <button mat-flat-button (click)="onCloneRoster()" matTooltip="Clone Roster"
                *ngIf="header && !isNoShopsSelected()">
                <mat-icon>content_copy</mat-icon>
                <span>Clone</span>
            </button>
            <button mat-flat-button (click)="toggleAutoFit()" matTooltip="Auto Fit to Screen Width"
                [style.background-color]="isAutoFit ? '#e0f2fe !important' : 'white !important'"
                [style.color]="isAutoFit ? '#0369a1 !important' : '#4a5568 !important'"
                [style.border-color]="isAutoFit ? '#bae6fd !important' : '#e2e8f0 !important'">
                <mat-icon>{{ isAutoFit ? 'fit_screen' : 'zoom_out_map' }}</mat-icon>
                <span>{{ isAutoFit ? 'Auto Fit' : 'Auto Fit' }}</span>
            </button>
            <button mat-flat-button (click)="toggleFullscreen()">
                <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                <span>{{ isFullscreen ? 'Minimize' : 'Fullscreen' }}</span>
            </button>
            <button mat-flat-button (click)="print()" *ngIf="!isNoShopsSelected()">
                <mat-icon>print</mat-icon>
                <span>Print</span>
            </button>
            <button mat-flat-button (click)="exportRoster()" *ngIf="!isNoShopsSelected() && !isViewerMode()"
                [disabled]="IsDownloading">
                <mat-icon>download</mat-icon>
                <span>Export</span>
            </button>

            <button mat-flat-button color="primary" (click)="submitRoster()" [disabled]="header?.is_submitted == 1"
                *ngIf="header && !isNoShopsSelected()" style="background-color: #047857; color: white;">
                <mat-icon>{{ header?.is_submitted == 1 ? 'check_circle' : 'send' }}</mat-icon>
                <span>{{ header?.is_submitted == 1 ? 'SUBMITTED' : 'SUBMIT' }}</span>
            </button>

            <button mat-flat-button (click)="onClose()" class="close-btn">
                <mat-icon>close</mat-icon>
                <span>Close</span>
            </button>

            <button mat-flat-button color="accent" (click)="sendRosterMail()"
                *ngIf="!isNoShopsSelected() && !isViewerMode()" [disabled]="isSendingMail" style="margin-left: 8px;">
                <mat-icon *ngIf="!isSendingMail">email</mat-icon>
                <span>{{ isSendingMail ? 'Sending...' : 'Email' }}</span>
            </button>
            <button (click)="toggleSummaryColumn()" matTooltip="Toggle Summary Column"
                style="border: 1px solid #e2e8f0; background: white; margin-right: 8px;  min-width: unset; padding: 5px !important;">
                <img style="height: 35px;" [src]="showSummaryColumn ? 'assets/images/icons/pane-close.svg'
                    : 'assets/images/icons/pane-open.svg'">
            </button>
        </div>
    </div>

    <!-- Roster Grid -->
    <div class="roster-viewport" cdkScrollable #rosterViewport>
        <app-loader *ngIf="isLoading" [show]="isLoading"></app-loader>
        <div class="roster-grid-wrapper" *ngIf="header && !isNoShopsSelected()" cdkDropListGroup
            [style.grid-template-columns]="getGridTemplateColumns()" [style.zoom]="zoomLevel + '%'">

            <!-- Column Headers (Days) -->
            <div class="grid-cell header-cell staff-list-header sticky-col" *ngIf="showEmployeeColumn">
                <div class="header-title-row"
                    style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; width: 100%; height: 100%;">
                    <div class="week-number-header" *ngIf="!showSearchInput"
                        style="font-size: 1rem; color: #718096; font-weight: 600;  text-align: right imprt !important; margin-bottom: 2px; line-height: 1;">
                        Week {{ header.week_number }}</div>
                    <div class="day-label" *ngIf="!showSearchInput" style="margin-bottom: 8px;">Employee</div>
                    <input *ngIf="showSearchInput" type="text" [(ngModel)]="searchQuery" placeholder="Search..."
                        style="width: 100%; min-width: 0; margin-bottom: 8px; padding: 2px 4px; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 0.85rem; height: 24px; outline: none;">

                    <div class="header-icons" style="display: flex; gap: 12px; align-self: flex-end; margin-top: auto;">
                        <mat-icon
                            style="font-size: 1.45rem; color: #718096; cursor: pointer; width: 24px; height: 24px; display: flex; justify-content: center; align-items: center;"
                            (click)="toggleSearch()" matTooltip="Search Employees">search</mat-icon>
                        <mat-icon
                            style="font-size: 1.45rem; color: #718096; cursor: pointer; width: 24px; height: 24px; display: flex; justify-content: center; align-items: center;"
                            (click)="hideEmptyEmployees = !hideEmptyEmployees"
                            [matTooltip]="hideEmptyEmployees ? 'Show All Employees' : 'Hide Empty Employees'">
                            {{ hideEmptyEmployees ? 'group' : 'person_off' }}
                        </mat-icon>
                        <mat-icon
                            style="font-size: 1.45rem; color: #718096; cursor: pointer; width: 24px; height: 24px; display: none; justify-content: center; align-items: center;"
                            (click)="toggleEmployeeDetails()" matTooltip="Toggle Details">
                            {{ showEmployeeDetails ? 'visibility' : 'visibility_off' }}
                        </mat-icon>
                        <mat-icon
                            style="font-size: 1.45rem; color: #718096; cursor: pointer; width: 24px; height: 24px; display: flex; justify-content: center; align-items: center;"
                            (click)="toggleSort()" matTooltip="Sort Employees">
                            {{ sortOrder === 'asc' ? 'arrow_downward' : (sortOrder === 'desc' ? 'arrow_upward' :
                            'filter_list') }}
                        </mat-icon>
                    </div>
                </div>
            </div>
            <div class="grid-cell header-cell" *ngFor="let day of weekDays; let i = index" cdkDropList
                [cdkDropListData]="{type: 'day', date: day.date}" (cdkDropListDropped)="onDayDrop($event)"
                [cdkDropListEnterPredicate]="dropPredicate"
                style="padding: 0;" [class.missing-ic-border]="isMissingOpenerIC(day.date)"
                [ngClass]="'header-status-' + getDayHeaderStatus(day.date)" [cdkDropListDisabled]="isViewerMode()">
                <div class="day-drag-wrapper" cdkDrag [cdkDragStartDelay]="{ touch: 350, mouse: 0 }" [cdkDragData]="{type: 'day', date: day.date}"
                    (cdkDragMoved)="onDragMoved($event)" (click)="!isViewerMode() && handleDayHeaderClick(day)"
                    style="width: 100%; height: 100%; padding: 8px; box-sizing: border-box; display: flex; flex-direction: column; justify-content: center;"
                    [style.cursor]="isViewerMode() ? 'default' : (getDayHeaderStatus(day.date) === 'empty' ? 'default' : 'pointer')"
                    [cdkDragDisabled]="isViewerMode()"
                    [attr.title]="isMissingOpenerIC(day.date) ? 'Missing In-Charge task. Click to view details.' : (getDayHeaderStatus(day.date) === 'ready' ? 'Ready to finalise. Click to finalise.' : (getDayHeaderStatus(day.date) === 'exceptions' ? 'Has exceptions. Click to review.' : (getDayHeaderStatus(day.date) === 'finalised' ? 'Finalised. Click to reopen.' : (getDayHeaderStatus(day.date) === 'empty' ? 'No shifts on this day.' : 'Drag to copy ' + day.dayName + ' roster'))))">
                    <div class="day-label"
                        style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; width: 100%;">
                        <span>{{ day.dayName }} {{ day.dayNum }} {{ day.monthName }}</span>
                        <!-- Tick for Ready to Finalise -->
                        <mat-icon
                            style="color: #137333; background: white; border-radius: 50%; font-size: 18px; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; vertical-align: middle; margin-left: 4px;"
                            *ngIf="getDayHeaderStatus(day.date) === 'ready'">check_circle</mat-icon>

                        <!-- Warning/Exclamation for Has Exceptions -->
                        <mat-icon
                            style="color: #dd6b20; font-size: 18px; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; vertical-align: middle; margin-left: 4px;"
                            *ngIf="getDayHeaderStatus(day.date) === 'exceptions'">warning</mat-icon>

                        <!-- Lock for Finalised -->
                        <mat-icon
                            style="color: #1a73e8; font-size: 18px; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; vertical-align: middle; margin-left: 4px;"
                            *ngIf="getDayHeaderStatus(day.date) === 'finalised'">lock</mat-icon>
                        <div *cdkDragPreview class="day-drag-preview"
                            style="background: #ebf8ff; color: #2b6cb0; padding: 8px 12px; border-radius: 6px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); font-weight: 600;">
                            Copy {{ day.dayName }}'s Roster
                        </div>
                    </div>
                    <div class="day-stats">
                        {{ getDailyStats(day.date).empCount }} Emp |
                        {{ getDailyStats(day.date).hours | number:'1.2-2' }}h<span class="day-stats-cost" *ngIf="canViewWagesCost"> | ${{
                            getDailyStats(day.date).cost | number:'1.0-0' }}</span>
                    </div>
                </div>
            </div>

            <!-- Total Summary Header -->
            <div class="grid-cell summary-cell header-cell" *ngIf="showSummaryColumn">
                <div class="summary-header-content">
                    <div class="main-label" style="text-align: center;">WEEK SUMMARY</div>
                    <div class="sub-label" style="text-align: center;">
                        <span class="sub-label-default">{{ canViewWagesCost ? 'Hours / Wages' : 'Hours' }}</span>
                        <span class="sub-label-print">Hours</span>
                    </div>
                </div>
            </div>

            <!-- Employee Rows -->
            <ng-container *ngFor="let emp of filteredAndSortedEmployees; let idx = index">
                <!-- Sidebar Info Cell -->
                <div class="grid-cell employee-cell sticky-col" *ngIf="showEmployeeColumn"
                    [class.clickable-warning]="hasConsecutiveWorkDays(emp.id, 6)"
                    [style.border-left-color]="getThemeColor(emp)" (click)="handleEmployeeCellClick(emp)">
                    <ng-container *ngIf="getComplianceStatus(emp) as compliance">
                        <div class="emp-header">
                            <div class="emp-name-wrapper">
                                <mat-icon class="compliance-status-icon"
                                    *ngIf="compliance.status !== 'ok' && compliance.totalHours > 0"
                                    [matTooltip]="compliance.message" [ngClass]="compliance.colorClass + '-text'"
                                    (click)="$event.stopPropagation(); showComplianceMessage(emp, compliance)">
                                    warning
                                </mat-icon>
                                <mat-icon class="compliance-status-icon compliance-red-text"
                                    *ngIf="hasConsecutiveWorkDays(emp.id, 6)"
                                    [matTooltip]="'Assigned for 6 consecutive work days in this week.'"
                                    (click)="$event.stopPropagation(); handleEmployeeCellClick(emp)">
                                    warning
                                </mat-icon>
                                <div class="emp-name" [title]="getEmployeeDisplayName(emp)">
                                    {{ getEmployeeDisplayName(emp) }}
                                </div>
                            </div>
                            <div class="multi-shop-indicator" *ngIf="hasMultiShopShifts(emp.id)"
                                [matTooltip]="'Rostered at multiple shops'"
                                (click)="$event.stopPropagation(); showMultiShopDetails(emp)">
                                <mat-icon>domain</mat-icon>
                            </div>
                        </div>
                        <div class="emp-sub" [title]="emp.title_name">{{ emp.title_name }}</div>

                        <div class="emp-progress" *ngIf="compliance.totalHours > 0" [attr.title]="compliance.message"
                            [ngClass]="compliance.colorClass + '-text'">
                            <span class="badge badge-roster" [class.multi-shop]="hasMultiShopShifts(emp.id)"
                                (click)="onRosterBadgeClick($event, emp)">R</span>
                            <span class="current-val">{{ compliance.totalHours | number:'1.2-2' }}</span>
                            <div class="progress-bar" [ngClass]="compliance.colorClass">
                                <ng-container *ngIf="hasMultiShopShifts(emp.id); else singleRosterFill">
                                    <div class="fill"
                                        *ngFor="let seg of getRosterSegments(emp.id, compliance.percentage)"
                                        [style.width.%]="seg.width" [style.background-color]="seg.color"></div>
                                </ng-container>
                                <ng-template #singleRosterFill>
                                    <div class="fill" [style.width.%]="compliance.percentage"></div>
                                </ng-template>
                            </div>
                            <span class="max-val" *ngIf="compliance.max > 0">{{ compliance.max | number:'1.2-2'
                                }}</span>
                        </div>

                        <div class="emp-progress"
                            *ngIf="compliance.totalHours > 0 && isPastOrCurrentWeek() && canViewAttendance && getActualComplianceStatus(emp) as actCompliance"
                            [ngClass]="actCompliance.colorClass + '-text'">
                            <span class="badge badge-actual">A</span>
                            <span class="current-val">{{ actCompliance.totalHours | number:'1.2-2' }}</span>
                            <div class="progress-bar" [ngClass]="actCompliance.colorClass">
                                <div class="fill" [style.width.%]="actCompliance.percentage"></div>
                            </div>
                            <span class="max-val" *ngIf="actCompliance.max > 0">{{ actCompliance.max | number:'1.2-2'
                                }}</span>
                        </div>
                    </ng-container>
                </div>

                <!-- Day Shift Cells -->
                <div class="grid-cell shift-cell" *ngFor="let day of weekDays"
                    [class.is-on-leave]="isEmployeeOnLeave(emp.id, day.date)"
                    [class.is-inactive-day]="!isEmployeeActiveOnDate(emp.id, day.date)"
                    [style.background-color]="!isEmployeeActiveOnDate(emp.id, day.date) ? '#f9f9f9' : null"
                    (click)="isEmployeeActiveOnDate(emp.id, day.date) && !isEmployeeOnLeave(emp.id, day.date) && openShiftModal(emp, day.date)"
                    cdkDropList [cdkDropListData]="{emp: emp, date: day.date}" (cdkDropListDropped)="onDrop($event)"
                    [cdkDropListDisabled]="header?.is_submitted == 1 || isEmployeeOnLeave(emp.id, day.date) || !isEmployeeActiveOnDate(emp.id, day.date)"
                    [cdkDropListEnterPredicate]="dropPredicate">

                    <!-- Inactive employee assignment display -->
                    <div class="inactive-cell-content" *ngIf="!isEmployeeActiveOnDate(emp.id, day.date)"
                        matTooltip="Employee has no active shop assignment on this date"
                        style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; height: 100%; opacity: 0.65; user-select: none; pointer-events: none; padding: 4px 0;">
                        <mat-icon style="color: #c0c0c0; font-size: 16px; width: 16px; height: 16px;">block</mat-icon>
                        <span
                            style="color: #909090; font-size: 10px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px;">Inactive</span>
                    </div>

                    <div class="leave-tile"
                        *ngIf="isEmployeeActiveOnDate(emp.id, day.date) && getLeaveForEmployeeAndDate(emp.id, day.date) as leaveBreak"
                        [matTooltip]="leaveBreak.remarks"
                        [style.background-color]="settingsColors?.leave_bg_color || '#fff5f7'"
                        [style.color]="settingsColors?.leave_bg_color ? getContrastColor(settingsColors.leave_bg_color) : '#d53f8c'"
                        [style.border-color]="settingsColors?.leave_bg_color ? settingsColors.leave_bg_color : '#fed7e2'"
                        style="border: unset;">
                        <mat-icon
                            [style.color]="settingsColors?.leave_bg_color ? getContrastColor(settingsColors.leave_bg_color) : '#ed64a6'">event_busy</mat-icon>
                        <span class="leave-type-text">{{ leaveBreak.leave_type_name }}</span>
                    </div>

                    <ng-container
                        *ngIf="isEmployeeActiveOnDate(emp.id, day.date) && !isEmployeeOnLeave(emp.id, day.date)">
                        <div class="shift-tiles" [class.is-dirty-tiles]="hasDirtyShift(emp.id, day.date)"
                            [class.is-last-edited-tiles]="hasLastEditedShift(emp.id, day.date)"
                            *ngIf="getShiftsForEmployeeAndDate(emp.id, day.date).length > 0; else emptyCell">
                            <div class="shift-tile-container"
                                *ngFor="let shift of getShiftsForEmployeeAndDate(emp.id, day.date)"
                                [class.other-shop-shift]="isOtherShopShift(shift)">
                                <!-- Static Original Tile: Stays visible while dragging -->
                                <div class="shift-tile"
                                    [style.background-color]="isInactiveShift(shift) && settingsColors?.unavilable_bg_color ? settingsColors.unavilable_bg_color : getThemeColor(emp)"
                                    [style.color]="isInactiveShift(shift) && settingsColors?.unavilable_bg_color ? getContrastColor(settingsColors.unavilable_bg_color) : getThemeTextColor(emp)"
                                    [style.border-color]="shift.is_in_charge && !isInactiveShift(shift) ? (settingsColors?.inc_color || '#126ef1') : (isInactiveShift(shift) && settingsColors?.unavilable_bg_color ? settingsColors.unavilable_bg_color : getThemeColor(emp))"
                                    [ngClass]="{
                                     'readonly-shift': isInactiveShift(shift),
                                     'in-charge-shift': shift.is_in_charge && !isInactiveShift(shift),
                                     'is-last-edited-shift': shift.id === lastEditedShiftId && !isInactiveShift(shift)
                                 }">
                                    <!-- 1st row: Tasks & Status Indicators -->
                                    <div class="tile-row-first">
                                        <div class="tasks-col" *ngIf="!isInactiveShift(shift)">
                                            <div class="task-chip" *ngIf="shift.task_id1"
                                                [style.--task-color]="getTaskColor(shift.task_id1, 'bg')">
                                                {{ getTaskCode(shift.task_id1) }}
                                            </div>
                                            <div class="task-chip" *ngIf="shift.task_id2"
                                                [style.--task-color]="getTaskColor(shift.task_id2, 'bg')">
                                                {{ getTaskCode(shift.task_id2) }}
                                            </div>
                                            <div class="task-chip" *ngIf="shift.task_id3"
                                                [style.--task-color]="getTaskColor(shift.task_id3, 'bg')">
                                                {{ getTaskCode(shift.task_id3) }}
                                            </div>
                                        </div>
                                        <div class="status-col">
                                            <span class="shop-code" *ngIf="shift.shop_code && isInactiveShift(shift)">{{
                                                shift.shop_code }}</span>
                                            <ng-container *ngIf="!isInactiveShift(shift)">
                                                <!-- Finalised: blue lock -->
                                                <mat-icon
                                                    style="color: #1a73e8; font-size: 18px; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;"
                                                    *ngIf="shift.is_finalized && !shift.is_absent">lock</mat-icon>

                                                <!-- Manually resolved exception: orange circle + white tick -->
                                                <mat-icon
                                                    style="color: #dd6b20; background: white; border-radius: 50%; font-size: 18px; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;"
                                                    *ngIf="!shift.is_finalized && isShiftReviewed(shift)"
                                                    [matTooltip]="'Reviewed: ' + getShiftWarningMessage(shift)">check_circle</mat-icon>

                                                <!-- Within threshold: green circle + white tick -->
                                                <mat-icon
                                                    style="color: #137333; background: white; border-radius: 50%; font-size: 18px; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;"
                                                    *ngIf="!shift.is_finalized && !isShiftReviewed(shift) && getShiftStatus(shift) === 'green'">check_circle</mat-icon>

                                                <!-- Unresolved Exception: orange exclamation/warning -->
                                                <mat-icon
                                                    style="color: #dd6b20; font-size: 18px; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;"
                                                    *ngIf="!shift.is_finalized && !isShiftReviewed(shift) && (getShiftStatus(shift) === 'red' || getShiftStatus(shift) === 'orange' || getShiftStatus(shift) === 'purple')"
                                                    [matTooltip]="getShiftWarningMessage(shift)">warning</mat-icon>
                                            </ng-container>
                                        </div>
                                    </div>

                                    <!-- 2nd row: Roster time & duration -->
                                    <div class="tile-row-second"
                                        [style.color]="settingsColors?.rostered_hour_color || '#3182ce'">
                                        <span class="time-range">{{ shift.start_time ? (shift.start_time | slice:0:5) :
                                            '--:--' }} - {{ shift.end_time ? (shift.end_time | slice:0:5) : '--:--'
                                            }}</span>
                                        <span class="duration">{{ shift.is_unscheduled ? '--:--' :
                                            getShiftDurationFormatted(shift) }}</span>
                                    </div>

                                    <!-- 3rd row: Actual time & duration -->
                                    <div class="tile-row-third" *ngIf="isPastOrCurrentWeek() && !isInactiveShift(shift) && canViewAttendance">
                                        <ng-container *ngIf="shift.is_absent; else showActualTime">
                                            <span style="color: #dc2626; font-weight: bold; font-size: 14px;">Absent</span>
                                        </ng-container>
                                        <ng-template #showActualTime>
                                            <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; color: inherit;">
                                                <span class="time-range" [style.color]="settingsColors?.actual_hour_color || '#000000'">
                                                    {{ getActualStartTimeDisplay(shift) }} - {{ getActualEndTimeDisplay(shift) }}
                                                </span>
                                                <span class="duration" [style.color]="settingsColors?.actual_hour_color || '#000000'"
                                                    [class.no-attendance-hours]="!shift.act_shift_start_time">
                                                    {{ getActualShiftDurationFormatted(shift) }}
                                                </span>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>

                                <!-- Invisible Drag Trigger Overlay -->
                                <div class="drag-overlay" [cdkDragDisabled]="shift.is_readonly || !canEditShift" cdkDrag
                                    [cdkDragStartDelay]="{ touch: 350, mouse: 0 }"
                                    [cdkDragData]="shift" (cdkDragMoved)="onDragMoved($event)"
                                    [style.cursor]="(shift.is_readonly || !canEditShift) ? 'default' : 'grab'"
                                    (click)="handleShiftClick($event, emp, day.date, shift)">

                                    <!-- Empty placeholder so target cells don't change visually -->
                                    <div *cdkDragPlaceholder></div>

                                    <!-- High Fidelity Drag Preview -->
                                    <div *cdkDragPreview class="shift-tile preview-tile"
                                        [style.background-color]="isInactiveShift(shift) && settingsColors?.unavilable_bg_color ? settingsColors.unavilable_bg_color : getThemeColor(emp)"
                                        [style.color]="isInactiveShift(shift) && settingsColors?.unavilable_bg_color ? getContrastColor(settingsColors.unavilable_bg_color) : getThemeTextColor(emp)"
                                        [style.border-color]="shift.is_in_charge && !isInactiveShift(shift) ? (settingsColors?.inc_color || '#126ef1') : (isInactiveShift(shift) && settingsColors?.unavilable_bg_color ? settingsColors.unavilable_bg_color : getThemeColor(emp))"
                                        [ngClass]="{
                                         'readonly-shift': isInactiveShift(shift),
                                         'in-charge-shift': shift.is_in_charge && !isInactiveShift(shift),
                                         'is-last-edited-shift': shift.id === lastEditedShiftId && !isInactiveShift(shift)
                                    }">
                                        <!-- 1st row: Tasks & Status Indicators -->
                                        <div class="tile-row-first">
                                            <div class="tasks-col" *ngIf="!isInactiveShift(shift)">
                                                <div class="task-chip" *ngIf="shift.task_id1"
                                                    [style.--task-color]="getTaskColor(shift.task_id1, 'bg')">
                                                    {{ getTaskCode(shift.task_id1) }}
                                                </div>
                                                <div class="task-chip" *ngIf="shift.task_id2"
                                                    [style.--task-color]="getTaskColor(shift.task_id2, 'bg')">
                                                    {{ getTaskCode(shift.task_id2) }}
                                                </div>
                                                <div class="task-chip" *ngIf="shift.task_id3"
                                                    [style.--task-color]="getTaskColor(shift.task_id3, 'bg')">
                                                    {{ getTaskCode(shift.task_id3) }}
                                                </div>
                                            </div>
                                            <div class="status-col">
                                                <span class="shop-code"
                                                    *ngIf="shift.shop_code && isInactiveShift(shift)">{{ shift.shop_code
                                                    }}</span>
                                                <ng-container *ngIf="!isInactiveShift(shift)">
                                                    <!-- Finalised: blue lock -->
                                                    <mat-icon
                                                        style="color: #1a73e8; font-size: 18px; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;"
                                                        *ngIf="shift.is_finalized && !shift.is_absent">lock</mat-icon>

                                                    <!-- Manually resolved exception: orange circle + white tick -->
                                                    <mat-icon
                                                        style="color: #dd6b20; background: white; border-radius: 50%; font-size: 18px; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;"
                                                        *ngIf="!shift.is_finalized && isShiftReviewed(shift)"
                                                        [matTooltip]="'Reviewed: ' + getShiftWarningMessage(shift)">check_circle</mat-icon>

                                                    <!-- Within threshold: green circle + white tick -->
                                                    <mat-icon
                                                        style="color: #137333; background: white; border-radius: 50%; font-size: 18px; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;"
                                                        *ngIf="!shift.is_finalized && !isShiftReviewed(shift) && getShiftStatus(shift) === 'green'">check_circle</mat-icon>

                                                    <!-- Unresolved Exception: orange exclamation/warning -->
                                                    <mat-icon
                                                        style="color: #dd6b20; font-size: 18px; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;"
                                                        *ngIf="!shift.is_finalized && !isShiftReviewed(shift) && (getShiftStatus(shift) === 'red' || getShiftStatus(shift) === 'orange' || getShiftStatus(shift) === 'purple')"
                                                        [matTooltip]="getShiftWarningMessage(shift)">warning</mat-icon>
                                                </ng-container>
                                            </div>
                                        </div>

                                        <!-- 2nd row: Roster time & duration -->
                                        <div class="tile-row-second"
                                            [style.color]="settingsColors?.rostered_hour_color || '#3182ce'">
                                            <span class="time-range">{{ shift.start_time ? (shift.start_time |
                                                slice:0:5) : '--:--' }} - {{ shift.end_time ? (shift.end_time |
                                                slice:0:5) : '--:--' }}</span>
                                            <span class="duration">{{ shift.is_unscheduled ? '--:--' :
                                                getShiftDurationFormatted(shift) }}</span>
                                        </div>

                                        <!-- 3rd row: Actual time & duration -->
                                        <div class="tile-row-third" *ngIf="isPastOrCurrentWeek() && !isInactiveShift(shift) && canViewAttendance">
                                            <ng-container *ngIf="shift.is_absent; else showActualTime">
                                                <span style="color: #dc2626; font-weight: bold; font-size: 14px;">Absent</span>
                                            </ng-container>
                                            <ng-template #showActualTime>
                                                <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; color: inherit;">
                                                    <span class="time-range" [style.color]="settingsColors?.actual_hour_color || '#000000'">
                                                        {{ getActualStartTimeDisplay(shift) }} - {{ getActualEndTimeDisplay(shift) }}
                                                    </span>
                                                    <span class="duration" [style.color]="settingsColors?.actual_hour_color || '#000000'"
                                                        [class.no-attendance-hours]="!shift.act_shift_start_time">
                                                        {{ getActualShiftDurationFormatted(shift) }}
                                                    </span>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #emptyCell>
                            <div class="empty-state">-</div>
                        </ng-template>
                    </ng-container>
                </div>

                <ng-container *ngIf="showSummaryColumn">
                    <div class="grid-cell summary-cell" *ngIf="getComplianceStatus(emp) as compliance"
                        [class.clickable-warning]="compliance.status !== 'ok'"
                        [class.split-summary-cell]="isPastOrCurrentWeek()"
                        (click)="compliance.status !== 'ok' && showComplianceMessage(emp, compliance)">
                        <div class="summary-row-content">
                            <div class="status-dot" [ngClass]="'dot-' + compliance.status"
                                *ngIf="!isPastOrCurrentWeek()"></div>

                            <div class="metrics-text" *ngIf="isPastOrCurrentWeek(); else futureSummary">
                                <div class="summary-roster-line"
                                    [style.color]="settingsColors?.rostered_hour_color || '#3182ce'">
                                    <span><span class="summary-hours-val">{{ getEmployeeFilteredHours(emp.id) |
                                            number:'1.2-2' }}h</span><ng-container *ngIf="canViewWagesCost"><span class="summary-cost-divider"> / </span><span
                                            class="summary-cost-val">${{ getEmployeeFilteredCost(emp) | number:'1.2-2'
                                            }}</span></ng-container></span>
                                    <mat-icon class="compliance-status-icon" *ngIf="compliance.status !== 'ok'"
                                        [ngClass]="compliance.colorClass + '-text'" [matTooltip]="compliance.message">
                                        warning
                                    </mat-icon>
                                </div>
                                <div class="summary-actual-line" *ngIf="canViewAttendance"
                                    [style.color]="settingsColors?.actual_hour_color || '#000000'">
                                    <span><span class="summary-hours-val">{{ getEmployeeActualFilteredHours(emp.id) |
                                            number:'1.2-2' }}h</span><ng-container *ngIf="canViewWagesCost"><span class="summary-cost-divider"> / </span><span
                                            class="summary-cost-val">${{ getEmployeeActualFilteredCost(emp) |
                                            number:'1.2-2' }}</span></ng-container></span>
                                </div>
                            </div>

                            <ng-template #futureSummary>
                                <div class="metrics-text">
                                    <div class="hours-val" style="display: inline-flex; align-items: center; gap: 4px;"
                                        [style.color]="settingsColors?.rostered_hour_color || '#1a202c'">
                                        <span>{{ getEmployeeFilteredHours(emp.id) | number:'1.2-2' }} hrs</span>
                                        <mat-icon class="compliance-status-icon" *ngIf="compliance.status !== 'ok'"
                                            [ngClass]="compliance.colorClass + '-text'"
                                            [matTooltip]="compliance.message"
                                            style="font-size: 14px; width: 14px; height: 14px; display: flex; align-items: center; justify-content: center; vertical-align: middle;">
                                            warning
                                        </mat-icon>
                                    </div>
                                    <div class="wages-val" *ngIf="canViewWagesCost"
                                        [style.color]="settingsColors?.rostered_hour_color || '#4a5568'">${{
                                        getEmployeeFilteredCost(emp) | number:'1.2-2' }}</div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <!-- Roster Summary Footer -->
            <!-- Total Hours Row -->
            <div class="roster-footer-row row-hours">
                <div class="footer-cell sticky-col" *ngIf="showEmployeeColumn">Total Hours (h)</div>
                <div class="footer-cell" *ngFor="let day of weekDays" [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureHours">
                        <div class="split-col rostered-col"
                            [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">
                            <span class="calc-value">{{ getDailyStats(day.date).hours | number:'1.2-2' }}</span>
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getDailyStats(day.date).actualHours | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <ng-template #futureHours>
                        <span class="calc-value">{{ getDailyStats(day.date).hours | number:'1.2-2' }}</span>
                    </ng-template>
                </div>
                <div class="footer-cell total-summary" *ngIf="showSummaryColumn"
                    [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureSummaryHours">
                        <div class="split-col rostered-col"
                            [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">
                            <span class="calc-value">{{ getWeeklyGrandTotal().hours | number:'1.2-2' }}</span>
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getWeeklyGrandTotal().actualHours | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <ng-template #futureSummaryHours>
                        <span class="calc-value">{{ getWeeklyGrandTotal().hours | number:'1.2-2' }}</span>
                    </ng-template>
                </div>
            </div>

            <!-- Total Wages Row -->
            <div class="roster-footer-row row-wages" *ngIf="canShowWagesRow">
                <div class="footer-cell sticky-col" *ngIf="showEmployeeColumn">Total Wages ($)</div>
                <div class="footer-cell" *ngFor="let day of weekDays" [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureWages">
                        <div class="split-col rostered-col"
                            [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">
                            <span class="calc-value">{{ getDailyStats(day.date).cost | number:'1.2-2' }}</span>
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getDailyStats(day.date).actualCost | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <ng-template #futureWages>
                        <span class="calc-value">{{ getDailyStats(day.date).cost | number:'1.2-2' }}</span>
                    </ng-template>
                </div>
                <div class="footer-cell total-summary" *ngIf="showSummaryColumn"
                    [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureSummaryWages">
                        <div class="split-col rostered-col"
                            [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">
                            <span class="calc-value">{{ getWeeklyGrandTotal().cost | number:'1.2-2' }}</span>
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getWeeklyGrandTotal().actualCost | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <ng-template #futureSummaryWages>
                        <span class="calc-value">{{ getWeeklyGrandTotal().cost | number:'1.2-2' }}</span>
                    </ng-template>
                </div>
            </div>

            <!-- Sales (Forecast vs. Actual) Row -->
            <div class="roster-footer-row row-sales" *ngIf="canShowSalesRow">
                <div class="footer-cell sticky-col" *ngIf="showEmployeeColumn">
                    <!-- {{ isPastOrCurrentWeek() ? 'Sales (Forecast vs. Actual)' : 'Sales Forecast' }} -->
                    Sales ($)
                </div>
                <div class="footer-cell" *ngFor="let day of weekDays" [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureSales">
                        <div class="split-col rostered-col flex-input"
                            [style.color]="(!canEditSales || isViewerMode()) ? '#94a3b8' : (settingsColors?.rostered_hour_color || '#0056b3')">
                            <!-- <span class="input-currency">$</span> -->
                            <input type="number" [ngModel]="header[getDayKey(day.date) + '_sales_forecast']"
                                (ngModelChange)="updateHeaderMetric(getDayKey(day.date), 'sales_forecast', $event)"
                                (blur)="onHeaderMetricBlur()"
                                placeholder="0" [style.color]="(!canEditSales || isViewerMode()) ? '#94a3b8' : (settingsColors?.rostered_hour_color || '#0056b3')"
                                [disabled]="isViewerMode() || !canEditSales"
                                [readonly]="isViewerMode() || !canEditSales">
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getDailyStats(day.date).actualSales | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <ng-template #futureSales>
                        <input type="number" [ngModel]="header[getDayKey(day.date) + '_sales_forecast']"
                            (ngModelChange)="updateHeaderMetric(getDayKey(day.date), 'sales_forecast', $event)"
                            (blur)="onHeaderMetricBlur()"
                            placeholder="0" [disabled]="isViewerMode() || !canEditSales"
                            [readonly]="isViewerMode() || !canEditSales"
                            [style.color]="(!canEditSales || isViewerMode()) ? '#94a3b8' : ''">
                    </ng-template>
                </div>
                <div class="footer-cell total-summary" *ngIf="showSummaryColumn"
                    [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureSummarySales">
                        <div class="split-col rostered-col"
                            [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">
                            <span class="calc-value" [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">{{
                                getWeeklyGrandTotal().sales | number:'1.2-2' }}</span>
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getWeeklyGrandTotal().actualSales | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <ng-template #futureSummarySales>
                        <span class="calc-value">{{ getWeeklyGrandTotal().sales | number:'1.2-2' }}</span>
                    </ng-template>
                </div>
            </div>

            <!-- Wage Target % Row -->
            <div class="roster-footer-row row-target" *ngIf="canShowTargetVarianceRows">
                <div class="footer-cell sticky-col" *ngIf="showEmployeeColumn">Wage Target (%)</div>
                <div class="footer-cell" *ngFor="let day of weekDays" [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureTarget">
                        <div class="split-col rostered-col"
                            [style.color]="(!canEditWagesCost || isViewerMode()) ? '#94a3b8' : (settingsColors?.rostered_hour_color || '#0056b3')">
                            <!-- <div class="split-col rostered-col"> -->
                            <input type="number" [ngModel]="header[getDayKey(day.date) + '_wage_target']"
                                (ngModelChange)="updateHeaderMetric(getDayKey(day.date), 'wage_target', $event)"
                                (blur)="onHeaderMetricBlur()"
                                placeholder="0.0" [style.color]="(!canEditWagesCost || isViewerMode()) ? '#94a3b8' : (settingsColors?.rostered_hour_color || '#0056b3')"
                                [disabled]="isViewerMode() || !canEditWagesCost"
                                [readonly]="isViewerMode() || !canEditWagesCost">
                            <!-- <span class="symbol">%</span> -->
                            <!-- </div> -->
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                (header[getDayKey(day.date) + '_wage_target'] || 0) |
                                number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <ng-template #futureTarget>
                        <!-- <div class="input-with-symbol"> -->
                        <input type="number" [ngModel]="header[getDayKey(day.date) + '_wage_target']"
                            (ngModelChange)="updateHeaderMetric(getDayKey(day.date), 'wage_target', $event)"
                            (blur)="onHeaderMetricBlur()"
                            placeholder="0.0" [disabled]="isViewerMode() || !canEditWagesCost"
                            [readonly]="isViewerMode() || !canEditWagesCost"
                            [style.color]="(!canEditWagesCost || isViewerMode()) ? '#94a3b8' : ''">
                        <!-- <span class="symbol">%</span> -->
                        <!-- </div> -->
                    </ng-template>
                </div>
                <div class="footer-cell total-summary" *ngIf="showSummaryColumn"
                    [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureSummaryTarget">
                        <div class="split-col rostered-col"
                            [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">
                            <span class="calc-value" [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">{{
                                getWeeklyGrandTotal().targetPct | number:'1.2-2' }}</span>
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getWeeklyGrandTotal().targetPct | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <ng-template #futureSummaryTarget>
                        <span class="calc-value">{{ getWeeklyGrandTotal().targetPct | number:'1.2-2' }}</span>
                    </ng-template>
                </div>
            </div>

            <!-- Rostered Wage % Row -->
            <div class="roster-footer-row row-rostered-pct" *ngIf="canShowTargetVarianceRows">
                <div class="footer-cell sticky-col" *ngIf="showEmployeeColumn">
                    {{ isPastOrCurrentWeek() ? 'Rostered Wage (%)' : 'Rostered Wage (%)' }}
                </div>
                <div class="footer-cell" *ngFor="let day of weekDays" [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureRosteredPct">
                        <div class="split-col rostered-col"
                            [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">
                            <span class="calc-value">{{ getDailyStats(day.date).rosteredWagePct | number:'1.2-2'
                                }}</span>
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getDailyStats(day.date).actualWagePct | number:'1.2-2'
                                }}</span>
                        </div>
                    </div>
                    <ng-template #futureRosteredPct>
                        <span class="calc-value">{{ getDailyStats(day.date).rosteredWagePct | number:'1.2-2' }}</span>
                    </ng-template>
                </div>
                <div class="footer-cell total-summary" *ngIf="showSummaryColumn"
                    [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureSummaryRosteredPct">
                        <div class="split-col rostered-col"
                            [style.color]="settingsColors?.rostered_hour_color || '#0056b3'">
                            <span class="calc-value">{{ getWeeklyGrandTotal().wagePct | number:'1.2-2' }}%</span>
                        </div>
                        <div class="split-col actual-col"
                            [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">
                            <span class="calc-value" [style.color]="settingsColors?.actual_hour_color || '#dd6b20'">{{
                                getWeeklyGrandTotal().actualWagePct | number:'1.2-2' }}%</span>
                        </div>
                    </div>
                    <ng-template #futureSummaryRosteredPct>
                        <span class="calc-value">{{ getWeeklyGrandTotal().wagePct | number:'1.2-2' }}%</span>
                    </ng-template>
                </div>
            </div>

            <!-- Wages Variance Row -->
            <div class="roster-footer-row row-variance" *ngIf="canShowTargetVarianceRows">
                <div class="footer-cell sticky-col" *ngIf="showEmployeeColumn">
                    {{ isPastOrCurrentWeek() ? 'Wage % Variance' : 'Wage % Variance' }}
                </div>
                <div class="footer-cell" *ngFor="let day of weekDays" [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureVariance">
                        <div class="split-col rostered-col">
                            <span class="calc-value"
                                [ngClass]="getDailyStats(day.date).variance > 0 ? 'variance-positive' : 'variance-negative'">
                                {{ getDailyStats(day.date).variance | number:'1.2-2' }}
                            </span>
                        </div>
                        <div class="split-col actual-col">
                            <span class="calc-value"
                                [ngClass]="getDailyStats(day.date).actualVariance > 0 ? 'variance-positive' : 'variance-negative'">
                                {{ getDailyStats(day.date).actualVariance | number:'1.2-2' }}
                            </span>
                        </div>
                    </div>
                    <ng-template #futureVariance>
                        <span class="calc-value"
                            [ngClass]="getDailyStats(day.date).variance > 0 ? 'variance-positive' : 'variance-negative'">
                            {{ getDailyStats(day.date).variance | number:'1.2-2' }}
                        </span>
                    </ng-template>
                </div>
                <div class="footer-cell total-summary" *ngIf="showSummaryColumn"
                    [class.future-week-cell]="!isPastOrCurrentWeek() || !canViewAttendance">
                    <div class="footer-cell-split" *ngIf="isPastOrCurrentWeek() && canViewAttendance; else futureSummaryVariance">
                        <div class="split-col rostered-col">
                            <span class="calc-value"
                                [ngClass]="getWeeklyGrandTotal().variance > 0 ? 'variance-positive' : 'variance-negative'">
                                {{ getWeeklyGrandTotal().variance | number:'1.2-2' }}
                            </span>
                        </div>
                        <div class="split-col actual-col">
                            <span class="calc-value"
                                [ngClass]="getWeeklyGrandTotal().actualVariance > 0 ? 'variance-positive' : 'variance-negative'">
                                {{ getWeeklyGrandTotal().actualVariance | number:'1.2-2' }}
                            </span>
                        </div>
                    </div>
                    <ng-template #futureSummaryVariance>
                        <span class="calc-value"
                            [ngClass]="getWeeklyGrandTotal().variance > 0 ? 'variance-positive' : 'variance-negative'">
                            {{ getWeeklyGrandTotal().variance | number:'1.2-2' }}
                        </span>
                    </ng-template>
                </div>
            </div>
        </div>

        <!-- No Shops Selected State -->
        <div class="no-shops-selected-container" *ngIf="isNoShopsSelected()">
            <div class="no-shops-card">
                <mat-icon class="no-shops-icon">storefront</mat-icon>
                <h2>No Shops Selected</h2>
                <p>No shops were selected. Please select a shop.</p>
                <button mat-flat-button color="primary" (click)="openShopSelection()" class="select-shops-btn">
                    <mat-icon>add_business</mat-icon>
                    <span>Select Shop</span>
                </button>
            </div>
        </div>
    </div>
</div>